import { Aggregator, Column } from 'angular-slickgrid';
import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';

export class MinAggregator extends SLAggregator {
	protected _name = 'min';
	protected _label = 'Min';
	constructor() {
		super();
	}
	init() {
		super.init();
	}
	Accumulate(item: any, column: Column<any>) {
		const val = item[column.id];
		if (isNaN(Number(val))) {
			return;
		}
		if ((!item[column.id] && (item[column.id] !== 0)) || isNaN(Number(item[column.id]))) {
			return;
		}
		if (this._value[column.id] === undefined) {
			this._value[column.id] = Number(val);
		} else {
			this._value[column.id] = Math.min(this._value[column.id], Number(val));
		}

	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);
	}
}